import Highcharts from 'highcharts';

// eslint-disable-next-line no-undef
jQuery(() => {
  Highcharts.Sparkline = function Sparkline(renderTo, individualOptions) {
    const defaultOptions = {
      chart: {
        backgroundColor: null,
        borderWidth: 0,
        type: 'area',
        margin: [0, 0, 0, 0],
        width: 80,
        height: 25,
        style: {
          overflow: 'visible',
        },
        skipClone: true,
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        labels: {
          enabled: false,
        },
        title: {
          text: null,
        },
        startOnTick: false,
        endOnTick: false,
        tickPositions: [],
        lineWidth: 0,
      },
      yAxis: {
        endOnTick: false,
        startOnTick: false,
        labels: {
          enabled: false,
        },
        title: {
          text: null,
        },
        tickWidth: 0,
        gridLineWidth: 0,
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        hideDelay: 0,
        outside: true,
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        series: {
          animation: false,
          lineWidth: 1,
          shadow: false,
          states: {
            hover: {
              lineWidth: 1,
            },
          },
          marker: {
            radius: 0,
            states: {
              hover: {
                radius: 2,
              },
            },
          },
          fillOpacity: 0.25,
        },
        column: {
          negativeColor: '#910000',
          borderColor: 'silver',
        },
      },
      exporting: {
        enabled: false,
      },
    };

    const options = Highcharts.merge(defaultOptions, individualOptions);

    return new Highcharts.Chart(renderTo, options);
  };
});
